import { AutocompleteStoreFactory } from 'common/module/autocomplete/store.factory';
import { BuildingReviewAutocompleteStoreDecorator } from 'desktop/module/building-review/autocomplete/store-decorator';
import { BuildingReviewAutocompleteStoreDecoratorInterface } from 'desktop/module/building-review/autocomplete/store-decorator.interface';

export function BuildingReviewAutocompleteStoreFactory(): BuildingReviewAutocompleteStoreDecoratorInterface {
  let autocompleteStore = AutocompleteStoreFactory();

  // Add property serp specific autocomplete logic
  autocompleteStore = new BuildingReviewAutocompleteStoreDecorator(autocompleteStore);

  return <BuildingReviewAutocompleteStoreDecorator>autocompleteStore;
}
